module.exports = __webpack_public_path__ + "img/ad-mew-wallet.a6ec5e61.png";